// ProposalsSlice.ts (or your slice file)
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define your initial state
interface ProposalsStateType {
  ProposalsError?: string | object | null | undefined | unknown;
  message: any;
  loading: any;
  proposals?: any;
}

export const initialState: ProposalsStateType = {
  ProposalsError: null,
  message: null,
  loading: false,
  proposals: null,
};

// Define your slice
const ProposalsSlice = createSlice({
  name: "proposals",
  initialState,
  reducers: {
    setProposalsSuccessful(state, action: PayloadAction<any>) {
      state.proposals = action.payload;
    },
    setProposalsFailed(state, action: PayloadAction<any>) {
      state.ProposalsError = action.payload;
    },
    clearProposals(state) {
      state.proposals = null;
    },
    // Add the `updateProposal` reducer here
    updateProposal(state, action: PayloadAction<any>) {
        const updatedProposal = action.payload;
        // console.log('redicer : updatedProposal' + JSON.stringify(updatedProposal));
        // console.log('state.proposals?.data' + JSON.stringify(state.proposals?.data)); // Access proposals.data safely

        if (Array.isArray(state.proposals?.data)) {
            // Only map if proposals.data is an array
            state.proposals.data = state.proposals.data.map((proposal: any) => {
                if (proposal.id === updatedProposal.id) {
                    // alert('Matched proposal id: ' + proposal.id); // 🔥 Alert when match found
                    return { ...proposal, ...updatedProposal };  // Update the matching proposal
                }
                return proposal;  // Return the unchanged proposal
            });
            // console.log("Updated full state:", JSON.stringify(state, null, 2));
        } else {
            console.warn('Proposals data is not an array or is null, cannot update.');
    }
      }
  },
});

// Export actions
export const {
  setProposalsSuccessful,
  setProposalsFailed,
  clearProposals,
  updateProposal, // Export the updateProposal action
} = ProposalsSlice.actions;

// Export the reducer
export default ProposalsSlice.reducer;
